module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/goodjob/2005_chanpachi_otsukare-705112a523a7b079d56f341b7d3bdff9.jpg";